export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8886.d113c202.jpg";